import { apiGet } from '../../api'

export const all_transactions = query => {
  return apiGet({
    endpoint: `transactions/all_transactions?${query}`
  })
}
